import { KeyRound } from 'lucide-react';
import { t } from '@/lib/i18n';
import { Callout, CopyButton, Input, Stack } from '@/ui';
import s from '../Admin.module.css';

/**
 * A secret shown exactly once (RULES §SEC-3): Nova stores only its hash, so after this dialog
 * closes nobody can see it again — a lost key is rotated, never retrieved.
 */
export function SecretReveal({ secret, name }: { secret: string; name: string }) {
  return (
    <Stack gap={3}>
      <Callout tone="warning" icon={KeyRound} title={t('Copy the key now — it is shown only once')}>
        {t('Nova keeps only a fingerprint of it. If it is lost, rotate the key to get a new secret.')}
      </Callout>
      <div className={s.secret}>
        <Input value={secret} readOnly mono aria-label={t('Secret of {name}', { name })} onFocus={(e) => e.currentTarget.select()} className={s.grow} />
        <CopyButton value={secret} label={t('Copy the key')} size="md" />
      </div>
      <p className={s.hint}>{t('Send it in the X-API-Key header. Never put it in a URL, a document or a chat.')}</p>
    </Stack>
  );
}
